export default "__VITE_ASSET__6a7b4d7a__"